(() => {
  let cleanup = () => {};
  function initialize() {
    cleanup();
    const root = document.documentElement;
    const ticker = document.querySelector('[data-vf-trust-ticker]');
    if (!ticker) { root.style.setProperty('--vf-ticker-height', '0px'); window.dispatchEvent(new Event('vf:ticker-layout')); return; }
    const track = ticker.querySelector('[data-vf-ticker-track]');
    const primary = ticker.querySelector('[data-vf-ticker-primary]');
    const duplicate = ticker.querySelector('[data-vf-ticker-duplicate]');
    const slot = ticker.querySelector('[data-vf-ticker-window]');
    const button = ticker.querySelector('[data-vf-ticker-pause]');
    const viewport = window.visualViewport;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const original = Array.from(primary.children).filter(node => node.getAttribute('aria-hidden') !== 'true').map(node => node.outerHTML).join('');
    let frame = 0, needsMeasure = true, active = true, lastLayout = '';
    let observedAside = null;
    const set = (node, name, value) => { if (node.style.getPropertyValue(name) !== value) node.style.setProperty(name, value); };
    function previewClearance(height) {
      let clear = 0;
      document.querySelectorAll('shopify-preview-bar, #preview-bar-iframe, #ShopifyPreviewBar, #PBarNextFrame, iframe[src*="preview_bar"], iframe[src*="preview-bar"]').forEach(bar => {
        const rect = bar.getBoundingClientRect();
        const style = getComputedStyle(bar);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        if (bar.id === 'PBarNextFrame' && rect.height > height * .6) {
          clear = Math.max(clear, matchMedia('(max-width: 749px)').matches ? 80 : 64);
        } else if (rect.height > 0 && rect.height < height * .4 && rect.top < height && rect.bottom >= height - 2) {
          clear = Math.max(clear, height - rect.top);
        }
      });
      return clear;
    }
    function measureTrack() {
      primary.innerHTML = original;
      const baseWidth = primary.getBoundingClientRect().width;
      const repeats = Math.max(1, Math.ceil((slot.clientWidth + 1) / Math.max(1, baseWidth)));
      const firstSequence = Array.from(primary.children);
      for (let i = 1; i < repeats; i++) {
        firstSequence.forEach(node => {
          const copy = node.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('data-shopify-editor-block');
          primary.appendChild(copy);
        });
      }
      duplicate.innerHTML = primary.innerHTML;
      duplicate.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
      const width = primary.getBoundingClientRect().width;
      const speed = Number(ticker.dataset.speed) || 45;
      set(track, '--vf-ticker-duration', (width / speed).toFixed(3) + 's');
      if (reduced.matches) {
        slot.tabIndex = 0;
        slot.setAttribute('aria-label', 'Shower benefits; scroll horizontally to read all phrases');
      } else {
        slot.removeAttribute('tabindex'); slot.removeAttribute('aria-label');
      }
    }
    function render() {
      frame = 0;
      if (!active || !ticker.isConnected) return;
      const height = window.innerHeight;
      const visibleTop = viewport?.offsetTop || 0;
      const visibleBottom = Math.min(height, visibleTop + (viewport?.height || height));
      const bottom = Math.max(0, height - visibleBottom, previewClearance(height));
      const usableBottom = height - bottom;
      set(root, '--vf-ticker-offset', bottom.toFixed(2) + 'px');
      set(root, '--vf-ticker-safe', bottom > 0 ? '0px' : 'env(safe-area-inset-bottom, 0px)');
      if (needsMeasure) { needsMeasure = false; measureTrack(); }
      const aside = document.querySelector('[data-vf-sticky-cart]');
      if (aside !== observedAside) {
        stickyState.disconnect(); observedAside = aside;
        if (aside) stickyState.observe(aside, { attributes: true, attributeFilter: ['class'] });
      }
      const product = document.querySelector('.vf-premium-product');
      const gallery = product?.querySelector('.product__media-wrapper, media-gallery');
      const buyBox = product?.querySelector('.product__info-container');
      const trigger = matchMedia('(max-width: 749px)').matches ? buyBox : gallery;
      const galleryPassed = Boolean(trigger && trigger.getBoundingClientRect().bottom <= visibleTop);
      // On mobile, keep the first purchase decision clear; desktop still reveals at gallery exit.
      const footer = document.querySelector('footer.footer') || document.querySelector('footer');
      const footerRect = footer?.getBoundingClientRect();
      const footerVisible = Boolean(footerRect && footerRect.height > 0 && footerRect.top < usableBottom && footerRect.bottom > visibleTop);
      const show = galleryPassed && !footerVisible;
      const state = String(show);
      if (ticker.dataset.visible !== state) ticker.dataset.visible = state;
      ticker.setAttribute('aria-hidden', String(!show));
      ticker.inert = !show;
      set(root, '--vf-ticker-height', show ? ticker.getBoundingClientRect().height.toFixed(2) + 'px' : '0px');
      const layout = state + ':' + bottom.toFixed(2) + ':' + ticker.getBoundingClientRect().height.toFixed(2);
      if (layout !== lastLayout) { lastLayout = layout; window.dispatchEvent(new Event('vf:ticker-layout')); }
    }
    function queue(measure = false) {
      if (!active) return;
      if (measure) needsMeasure = true;
      if (!frame) frame = requestAnimationFrame(render);
    }
    const queueVisibility = () => queue(false);
    const queueMeasure = () => queue(true);
    function toggle() {
      const paused = ticker.dataset.paused !== 'true';
      ticker.dataset.paused = String(paused);
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Resume benefit ticker' : 'Pause benefit ticker');
    }
    const sizes = new ResizeObserver(queueMeasure);
    sizes.observe(ticker); sizes.observe(slot);
    const guarantee = document.querySelector('[id$="__pp_guarantee_EantaB"]');
    const footer = document.querySelector('footer.footer') || document.querySelector('footer');
    if (guarantee) sizes.observe(guarantee);
    if (footer) sizes.observe(footer);
    const body = new MutationObserver(queueVisibility);
    body.observe(document.body, { childList: true });
    const stickyState = new MutationObserver(queueVisibility);
    button.addEventListener('click', toggle);
    window.addEventListener('scroll', queueVisibility, { passive: true });
    window.addEventListener('resize', queueMeasure, { passive: true });
    viewport?.addEventListener('resize', queueMeasure, { passive: true });
    viewport?.addEventListener('scroll', queueVisibility, { passive: true });
    reduced.addEventListener('change', queueMeasure);
    document.fonts?.ready.then(queueMeasure);
    queue(true);
    cleanup = () => {
      active = false;
      if (frame) cancelAnimationFrame(frame);
      sizes.disconnect(); body.disconnect(); stickyState.disconnect();
      button.removeEventListener('click', toggle);
      window.removeEventListener('scroll', queueVisibility);
      window.removeEventListener('resize', queueMeasure);
      viewport?.removeEventListener('resize', queueMeasure);
      viewport?.removeEventListener('scroll', queueVisibility);
      reduced.removeEventListener('change', queueMeasure);
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initialize));
})();
